import React from "react";
import "./PremiumLifestyle.css";
import energy from "../../assets/energy.png";
import global from "../../assets/global.png";
import commercial from "../../assets/commercial.png";
import home from "../../assets/home.png";
import solaricon from "../../assets/solar-icon.png";
import Aboutbutton from "../../assets/Aboutbutton.png";
import { Link } from "react-router-dom";

const RenewableEnergySection = () => {
  return (
    <section className="renew-section">
      
      {/* Right Badge Box */}
      <div className="renew-badge">
  <div className="renew-badge-top" style={{ backgroundColor: "#EFF3FF" }}>
    <p>Since 2019, our happy customers have avoided.</p>
  </div>

  <div className="renew-badge-line"></div>

  <div className="renew-badge-bottom" style={{ backgroundColor: "#193597" }}>
    <img src={solaricon} alt="Solar Icon" className="badge-icon" />
    <p className="renew-badge-title">600 Acres of Strategic Land Parcel</p>
  </div>
</div>

      {/* Content */}
      <div className="renew-content">
<p className="renew-breadcrumb" style={{ color: "#193597" }}>
  ABOUT › CM GROUP OF COMPANIES BUILDERS
</p>

        <h2 className="renew-heading">
          Pollachi's Premium Lifestyle <br /> & Landmark Builders
        </h2>

        <p className="renew-text">
          Welcome to CM Group of Companies, Promoters & Developers—a name synonymous with excellence and trust in Pollachi's development landscape. Our reputation is not just built on structures, but on the enduring quality and strategic vision of properties that consistently become landmarks in the city.
        </p>

        {/* Features */}
        <div className="renew-grid">
          <div className="renew-card">
            <img src={energy} alt="Energy Icon" />
            <h4>Respect for our customers</h4>
            <p>
              Respect fuels our transparency, 
ethical conduct, agility, and 
earnest customer partnership.
            </p>
          </div>

          <div className="renew-card">
            <img src={global} alt="Global Icon" />
            <h4>Transparency in all business dealings</h4>
            <p>
              Openness ensures ethical conduct, 
builds trust, and guarantees 
clear transactions.
            </p>
          </div>

          <div className="renew-card">
            <img src={commercial} alt="Commercial Icon" />
            <h4>Ethical Conduct as our foundation</h4>
            <p>
              Integrity is our bedrock, 
ensuring trust, fairness, and 
responsible business practices.
            </p>
          </div>

          <div className="renew-card">
            <img src={home} alt="Home Icon" />
            <h4>Residential use</h4>
            <p>
              Crafting premium homes: 
quality villas, apartments, and 
planned family communities.
            </p>
          </div>
        </div>

        <Link to="/contact" className="renew-btn" style={{ backgroundColor: "#EFF3FF" }}>
  <img src={Aboutbutton} alt="icon" className="renew-btn-icon" />
  Discover independence through the power of solar. <b>Explore our plans</b>
</Link>
      </div>
    </section>
  );
};

export default RenewableEnergySection;
